var articleInitColumns = (tempColumns, tempArticles, columnName, isDescSub) => {
  let columns = [
    {
      id: 0,
      name: columnName,
      article: tempArticles,
    },
  ];
  if (tempArticles.length == 0) {
    columns = [];
  }
  if (isDescSub) {
    for (let item in tempArticles) {
      if (item.desc) {
        item.desc = item.desc.substr(0, 130);
      }
    }
  }
  for (let i in tempColumns) {
    columns.push(tempColumns[i]);
  }
  return columns;
};
var fileInitColumns = (tempColumns, tempArticles, columnName) => {
  let columns = [
    {
      id: 0,
      name: columnName,
      downloadType: 0,
      fileList: tempArticles,
    },
  ];
  if (tempArticles.length == 0) {
    columns = [];
  }
  for (let i in tempColumns) {
    columns.push(tempColumns[i]);
  }
  return columns;
};

export default {
  articleInitColumns,
  fileInitColumns,
};
